// removed by extract-text-webpack-plugin
module.exports = {"songTools":"_1nwdT67h4iewsrXCQRE2Dp","mini":"_3ceMfniTr5nIA9Gnc6vQXb","highDisplayOnly":"_2Zb0ZzeAeeG4nKK9GsC1c1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SongTools/SongTools.scss
// module id = 827
// module chunks = 0